export enum AnalyticsEventNames {
  AddonModalViewed = "AddonModalViewed",
  AddonFetalSexCheckboxClicked = "AddonFetalSexCheckboxClicked",
  AddonFetalRhdCheckboxClicked = "AddonFetalRhdCheckboxClicked",
  // Archive Events
  OrderArchived = "OrderArchived",
  OrderUnarchived = "OrderUnarchived",
  // Video Library Events
  VideoLibraryPageView = "VideoLibraryPageView",
  VideoLibraryCardVideoClicked = "VideoLibraryCardVideoClicked",
  // Report Download Events
  MultiLanguageReportDownloaded = "MultiLanguageReportDownloaded",
  // Carrier Screen Attachment Events
  CarrierScreenAttachmentPopupShown = "CarrierScreenAttachmentPopupShown",
  CarrierScreenAttachmentAccepted = "CarrierScreenAttachmentAccepted",
  CarrierScreenAttachmentDeclined = "CarrierScreenAttachmentDeclined",
  CarrierScreenAttachmentClosed = "CarrierScreenAttachmentClosed",
  CarrierScreenAttachmentNoteShown = "CarrierScreenAttachmentNoteShown",
}
